import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import constants from 'src/constant.json';
import { environment } from 'src/environments/environment';
import { ProspektrApi } from '../_shared/api/prospektr.api';
import { BackendResponse } from '../_shared/interface/common.interface';
export interface AccountVerifyResponse {
  userVerification: boolean;
  Message: string;
}
@Injectable({
  providedIn: 'root',
})
export class VerifySignupService {
  private activateClientUserApi = 'activateClientUser';
  constructor(private http: HttpClient, private prospektrApi: ProspektrApi, private snackBar: MatSnackBar,) { }
  getSignUpVerification(id: string): Observable<any> {
    return new Observable((observer) => {
      if (!id) {
        observer.error(null);
      }
      const params = {
        registeredCompanyAppUserId: id,
      };
      this.http.post(environment.prospektrBackendBaseURL + constants.API.verifyAccount, params).subscribe(
        (res?: BackendResponse) => {
          if (res) {
            observer.next(res);
          } else {
            observer.error({ status: false, message: res.message ? res.message : 'Error occurred' });
          }
        },
        (error) => {
          observer.error({
            status: false,
            message: error.error && error.error.message ? error.error.message : 'Error occurred',
          });
        }
      );
    });
  }

  activateUser(activateUserParams: {
    registeredCompanyAppUserId: string;
    password: string;
    activateUserUrl: string;
  }): Observable<any> {
    let activateUserUrl = environment.prospektrBackendBaseURL + constants.API.activateUser;
    if (activateUserParams.activateUserUrl == 'activateClientUser') {
      activateUserUrl = environment.prospektrBackendBaseURL + this.activateClientUserApi;
    }
    return new Observable((observer) => {
      this.http.post<{ Message: string }>(activateUserUrl, activateUserParams).subscribe(
        (res) => {
          observer.next(res);
        },
        (error) => {
          observer.error(error.error);
        }
      );
    });
  }

  resendVerificationMail(params?) {
    return this.http.post(`${environment.prospektrBackendBaseURL
      }resendVerificationMail`, params);
  }

  private openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
}
